import { ActionType } from '../constants/ActionTypes';
import config from '../constants/Configs';
import { RestPath } from '../constants/SitePaths';
import { Constants } from '../constants/Constants';
import axios from 'axios';


export const getAnnouncementsBegin = () => ({
    type: ActionType.GET_ANNOUNCEMENT_BEGIN
})
export const getAnnouncementsSuccess = (data) => ({
    type: ActionType.GET_ANNOUNCEMENT_SUCCESS,
    payload: data
})
export const getAnnouncementsError = (data) => ({
    type: ActionType.GET_ANNOUNCEMENT_ERROR,
    payload: data
})

export function getAnnouncements(languageId) {
    return dispatch => {
        dispatch(getAnnouncementsBegin());
        return axios({
            url: config.BASE_URL + RestPath.GET_ANNOUNCEMENTS + `?languageId=${languageId}`,
            method: Constants.GET,
        })
            .then(response => {
                dispatch(getAnnouncementsSuccess(response.data));
                return response.data
            })
            .catch((error) => {
                dispatch(getAnnouncementsError(error.response && error.response.data));
            });
    };
}